import { render, staticRenderFns } from "./profileTab.vue?vue&type=template&id=a2e2eb7a&scoped=true&"
import script from "./profileTab.vue?vue&type=script&lang=js&"
export * from "./profileTab.vue?vue&type=script&lang=js&"
import style0 from "./profileTab.vue?vue&type=style&index=0&id=a2e2eb7a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2e2eb7a",
  null
  
)

export default component.exports